<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ data?.name }}
</h2>
<mat-dialog-content class="modal-content">

<div
    class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
    <div class="flex shrink-0">
        <!-- Search -->
        <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
            <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
            <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />
        </mat-form-field>
    </div>
    <!-- Actions -->
    <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
        <button mat-icon-button color="primary" (click)="addMembers()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
    </div>
</div>
<div class="container mt-0 flex-auto flex-col overflow-x-auto">
    <!-- Header -->
    <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
        <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceMembers" matSort
            (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Nombre</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left text-uppercase">
                    {{ element?.name}}
                </td>
            </ng-container>
            
            <!-- Company -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Correo</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left text-lowercase">
                    {{ element?.email.slice(0, 1).join(', ') }}
  
                    <ng-container *ngIf="element?.email.length > 1">
                        <span matTooltip="{{ element.email.slice(1).join(', ') }}">
                        , <b>+{{ element.email.length - 1 }} más</b>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Telefono</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left text-lowercase">
                    {{ element?.phone.slice(0, 1).join(', ') }}
  
                    <ng-container *ngIf="element?.phone.length > 1">
                        <span matTooltip="{{ element.phone.slice(1).join(', ') }}">
                        , <b>+{{ element.phone.length - 1 }} más</b>
                        </span>
                    </ng-container>
                </td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
                    
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="px-6 py-3 text-left">
                    <button mat-menu-item color="primary" (click)="openDeleteDialog(element, i)" matTooltip="Eliminar Registro">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

            <!-- Fila principal -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
        </table>
    </div>
    <div *ngIf="this.dataSourceMembers.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
</mat-dialog-actions>

<!-- Modal Agregar Miembro-->
<ng-template #actionModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ 'Nuevo' }} Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #modalForm="ngForm">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Miembro</mat-label>
                <mat-select [(ngModel)]="currentMemberMongoId" name="currentMemberMongoId" required>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchMember" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsMember($event)" placeholderLabel="Buscar miembro..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    @for (member of membersFilterList(); track member) {
                        <mat-option [value]="member._id" >
                            {{ member.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="onSubmit()"
            [disabled]="!modalForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #deleteDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
    </mat-dialog-actions>
</ng-template>

